import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Chip,
  Box,
  Typography,
} from "@mui/material";

function getInitials(name) {
  if (!name || typeof name !== "string") {
    return "KS";
  }

  const parts = name
    .trim()
    .split(" ")
    .filter(Boolean)
    .slice(0, 2);

  if (parts.length === 0) {
    return "KS";
  }

  return parts.map((part) => part[0]?.toUpperCase() ?? "").join("");
}

function ViewField({ label, value, fullWidth = false }) {
  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <Box
        sx={{
          p: 1.75,
          border: "1px solid #dfe8ef",
          borderRadius: 2.5,
          backgroundColor: "#ffffff",
          height: "100%",
          boxShadow: "0 1px 2px rgba(12, 35, 64, 0.06)",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "#5d7385",
            mb: 0.5,
            fontWeight: 700,
            letterSpacing: 0.2,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#11263a", fontWeight: 600, wordBreak: "break-word" }}
        >
          {value ?? "-"}
        </Typography>
      </Box>
    </Grid>
  );
}

export default function ExpencesTypeViewModal({ show, onHide, expenseData }) {
  const initials = getInitials(expenseData?.AccountName);

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          background:
            "radial-gradient(circle at top right, rgba(53, 99, 140, 0.08) 0%, rgba(53, 99, 140, 0) 35%), #f7fafd",
        },
      }}
    >
      <Box
        sx={{
          px: 3.5,
          py: 2.5,
          background: "linear-gradient(135deg, #15324b 0%, #24605c 100%)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.28)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1rem",
              fontWeight: 800,
              letterSpacing: 0.6,
            }}
          >
            {initials}
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {expenseData?.AccountName || "Detajet e Kategorisë"}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.92, mt: 0.35 }}>
              Shikim i të dhënave pa mundësi ndryshimi
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          <Chip
            label={expenseData?.IsActive ? "Aktiv" : "Jo Aktiv"}
            color={expenseData?.IsActive ? "success" : "default"}
            variant={expenseData?.IsActive ? "filled" : "outlined"}
            sx={{
              fontWeight: 800,
              backgroundColor: expenseData?.IsActive ? "#2e7d32" : "#dfe5ec",
              color: expenseData?.IsActive ? "#fff" : "#394b5a",
            }}
          />
        </Box>
      </Box>

      <DialogContent dividers sx={{ p: 3.5 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 3,
            border: "1px solid #dfe8ef",
            backgroundColor: "rgba(255,255,255,0.7)",
            mb: 2.5,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: "#1e5560", fontWeight: 800, mb: 1.25, letterSpacing: 0.2 }}
          >
            Informata Kryesore
          </Typography>
          <Grid container spacing={1.5}>
            <ViewField label="Emri i Kategorisë" value={expenseData?.AccountName} fullWidth />
            <ViewField label="Llogaria Kontabël" value={expenseData?.LedgerNameEN} fullWidth />
            <ViewField label="Komenti" value={expenseData?.Comment} fullWidth />
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3.5, py: 2.25, backgroundColor: "#edf4f8" }}>
        <Button
          onClick={onHide}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #1b4e57 0%, #284945 100%)",
            px: 3.5,
            fontWeight: 700,
            borderRadius: 2,
            "&:hover": {
              background: "linear-gradient(135deg, #153f46 0%, #203c39 100%)",
            },
          }}
        >
          Mbyll
        </Button>
      </DialogActions>
    </Dialog>
  );
}